import request from '@/api/request'



//收藏列表
export function collectList(data) {
    return request({
        url: '/api/collect/list',
        method: 'GET',
        params: data
    })
}
//PC职位/众包-收藏/取消收藏
export function addCollect(data) {
    return request({
        url: '/api/collect/addCollect',
        method: 'POST',
        data
    })
}




